export default "__VITE_ASSET__587af3fa__"